import React from "react";
import mapServiceItem from "./mapServiceItem";

export default function ProductionWorkflow({ items }) {
    return (
        <div className="production-workflow">
            {items.map((item) => {
                const card = mapServiceItem(item);

                return (
                    <article className="production-workflow-step" key={card.title}>
                        <span>{card.marker}</span>
                        <h3>{card.title}</h3>
                        <p>{card.text}</p>
                    </article>
                );
            })}
        </div>
    );
}
